import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';

import {
  generateCustomIndexFn,
  RouteTabGroupComponent,
  TabGroupConfig,
} from '@features/tab-group/route-tab-group.component';

import { ROUTING_PATH } from '@shared/constants/routingPath';
import { CmcService } from '@shared/services/cmc.service';
import { LaunchDarklyService } from '@shared/services/launch-darkly.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, RouteTabGroupComponent],
  selector: 'aux-budget',
  templateUrl: './budget.component.html',
})
export class BudgetComponent {
  private readonly cmcService = inject(CmcService);
  private readonly launchDarklyService = inject(LaunchDarklyService);

  indexFn = generateCustomIndexFn(
    `${ROUTING_PATH.BUDGET.INDEX}/${ROUTING_PATH.BUDGET.BUDGET.INDEX}`
  );
  tabs: TabGroupConfig[] = [
    {
      label: 'Vendor Budgets',
      route: ROUTING_PATH.BUDGET.BUDGET.VENDOR_BUDGET,
    },
    {
      label: 'Budget Library',
      route: ROUTING_PATH.BUDGET.BUDGET.LIBRARY,
      show: toObservable(
        this.launchDarklyService.$select((flags) => flags.tab_budget_budget_library)
      ),
    },
  ];
}
